import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import api from "../../lib/api";
import { SetPasswordButton } from "./SetPasswordButton";

export function AdminsTab() {
  const [admins, setAdmins] = useState([]);

  useEffect(() => {
    api.get("/admin/admins").then(({ data }) => setAdmins(data.admins));
  }, []);

  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="admins-list">
      {admins.map((a) => (
        <div key={a.id} className="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white p-4" data-testid={`admin-card-${a.id}`}>
          <div className="flex min-w-0 items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sky-100 text-blue-700"><ShieldCheck className="h-5 w-5" /></div>
            <div className="min-w-0">
              <p className="truncate font-heading font-700 text-slate-900">{a.nome} {a.cognome}</p>
              <p className="truncate text-xs text-slate-500">{a.email}</p>
            </div>
          </div>
          <SetPasswordButton user={a} name={`${a.nome} ${a.cognome}`} testid={`set-password-admin-${a.id}`} />
        </div>
      ))}
    </div>
  );
}
